export const POSTHOG_SUPPORT_FULL_CONTENT_WIDTH = 'mx-auto w-full max-w-4xl';

export function getPostHogSupportContentWidth(compact: boolean): string {
  return compact
    ? 'mx-auto w-full max-w-xl'
    : POSTHOG_SUPPORT_FULL_CONTENT_WIDTH;
}

export function getPostHogSupportHorizontalPadding(compact: boolean): string {
  return compact ? 'px-4' : 'px-4 sm:px-8';
}
